import React, { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { RootState } from '../redux/store';

const addLocation = connect((state: RootState) => ({
  location: state.router.location,
}));

export const ConnectedSwitch: ComponentType = addLocation((props) => <Switch {...props} />);
export const ConnectedRoute: ComponentType = addLocation((props) => <Route {...props} />);
